/**
 * Accordéons — ouverture et fermeture animées.
 *
 * `<details>` bascule instantanément : le CSS seul ne peut pas animer la hauteur.
 * On retarde la fermeture le temps de la transition, et on mesure la hauteur réelle
 * du contenu à l'ouverture plutôt que de deviner une valeur.
 */
const DURATION = 280;

const animate = (item) => {
  const wrap = item.querySelector('.acc__wrap');
  const panel = wrap?.firstElementChild;
  if (!wrap || !panel) return;

  const summary = item.querySelector('.acc__summary');
  if (!summary || summary.dataset.bound) return;
  summary.dataset.bound = 'true';

  summary.addEventListener('click', (event) => {
    event.preventDefault();

    if (item.open) {
      // Fermeture : on part de la hauteur actuelle vers zéro.
      wrap.style.height = `${panel.offsetHeight}px`;
      requestAnimationFrame(() => {
        wrap.style.height = '0px';
      });
      setTimeout(() => {
        item.open = false;
        wrap.style.height = '';
      }, DURATION);
      return;
    }

    // Une seule ligne ouverte à la fois : on referme les voisines.
    if (item.hasAttribute('name')) {
      const siblings = item.parentElement?.querySelectorAll('details[open]') ?? [];
      for (const other of siblings) {
        if (other !== item) other.querySelector('.acc__summary')?.click();
      }
    }

    item.open = true;
    wrap.style.height = '0px';
    requestAnimationFrame(() => {
      wrap.style.height = `${panel.offsetHeight}px`;
    });
    setTimeout(() => {
      wrap.style.height = '';
    }, DURATION);
  });

  // Une ligne ouverte au chargement ne doit pas rester bloquée à zéro.
  if (item.open) wrap.style.height = '';
};

let singleGroupCount = 0;

const init = () => {
  // Version bloc : « une seule ligne ouverte » se déclare sur le conteneur,
  // on propage l'attribut name aux details enfants pour grouper l'exclusivité.
  for (const group of document.querySelectorAll('[data-acc-single]')) {
    if (group.dataset.accGrouped) continue;
    group.dataset.accGrouped = String(++singleGroupCount);
    for (const d of group.querySelectorAll('details.acc__item')) {
      d.setAttribute('name', `acc-group-${group.dataset.accGrouped}`);
    }
  }
  for (const item of document.querySelectorAll('.acc__item')) animate(item);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', init);
}
